import { render, staticRenderFns } from "./CbsLocale.vue?vue&type=template&id=4648eed5"
import script from "./CbsLocale.vue?vue&type=script&lang=js"
export * from "./CbsLocale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports